import Dashboard from "../../../common/components/layout/Dashboard";
import Toast from "../../../common/components/ui/toast";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import TableRepossession from "./components/table-trafficfines/TableRepossession";

export function RepossessionReportsRegister() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableRepossession />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
